export default __webpack_public_path__ + "static/media/D036.e1ed8338.jpg";